import getRouterBasename from '@/lib/router';
import App from 'App';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useApi,
  useAuth,
  useChatInteract,
  useConfig
} from '@chainlit/react-client';



export default function AppWrapper() {
  const [translationLoaded, setTranslationLoaded] = useState(
    // En mode legalgraph on skip l'attente des traductions
    window.__APP_MODE__ === 'legalgraph' ? true : false
  );
  const { isAuthenticated, isReady } = useAuth();
  const { language: languageInUse } = useConfig();
  const { i18n } = useTranslation();
  const { windowMessage } = useChatInteract();

  function handleChangeLanguage(languageBundle: any): void {
    i18n.addResourceBundle(languageInUse, 'translation', languageBundle);
    i18n.changeLanguage(languageInUse);
  }

  // En mode legalgraph on charge quand même les traductions si disponibles
  // mais on ne bloque pas le rendu sur elles
  const { data: translations } = useApi<any>(
    window.__APP_MODE__ === 'legalgraph' ? null : `/project/translations?language=${languageInUse}`
  );

  useEffect(() => {
    if (window.__APP_MODE__ === 'legalgraph') return;
    if (!translations) return;
    handleChangeLanguage(translations.translation);
    setTranslationLoaded(true);
  }, [translations]);

  useEffect(() => {
    // En mode legalgraph on n'écoute pas les messages window (pas de copilot)
    if (window.__APP_MODE__ === 'legalgraph') return;

    const handleWindowMessage = (event: MessageEvent) => {
      windowMessage(event.data);
    };
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, [windowMessage]);

  // ── MODE LEGALCHAT : comportement original inchangé ───────────
  if (window.__APP_MODE__ !== 'legalgraph') {
    if (!translationLoaded) return null;

    const basename = getRouterBasename();

    const PUBLIC_PATHS = [
      basename + '/login',
      basename + '/login/callback',
      basename + '/forgot-password',
      basename + '/reset-password',
      basename + '/signup',
      basename + '/jurisprudence',
      basename + '/articles',
    ];

    if (isReady && !isAuthenticated) {
      const path = window.location.pathname;
      if (!PUBLIC_PATHS.some((p) => path.startsWith(p))) {
        window.location.href = basename + '/login';
      }
    }
  }

  // ── MODE LEGALGRAPH : rendu direct sans auth ni socket ────────
  return <App />;
}